export const navigateWithLang = (
  navigate: Function,
  path: string,
  lang: string
) => {
  if (lang === "de" && !path.endsWith("/de")) {
    navigate(path.endsWith("/") ? `${path}de` : `${path}/de`);
  } else if (lang === "us" && path.endsWith("/de")) {
    navigate(path.replace(/\/de$/, ""));
  } else {
    navigate(path);
  }
};
